import { getLocale } from '@/utils/localStorage';
import { LOCALES } from '@/utils/constants';

const locale = getLocale();

export function getCriterionLabel(criterion, moduleName = 'offer') {
  return locale === LOCALES.en && criterion.modules[moduleName].label_en ? criterion.modules.offer.label_en : criterion.modules.offer.label;
}
